var _defs, _g, _g2, _ellipse, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloqueDisjoncteur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_9",
    "data-name": "Calque 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1191 989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#9a3b39;}.cls-4{fill:#541716;}.cls-5{fill:#110d09;}.cls-6{fill:#150b08;}.cls-7{fill:#423836;}.cls-8{fill:#7f3131;}.cls-9{clip-path:url(#clip-path-2);}.cls-10{fill:#9b504d;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-503 -576)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M541,1214V1055s-8-2-10-44-7-144-7-144-.09-19.37,18-59c21-46,122-205,186-224a48.18,48.18,0,0,1,26,0c14,4,107,42,107,42s38,18,37,62,0,100,0,100c17.92,25.6,20,49.2,0,70V966l-19,34,33,14v111s-6,19-10,23c1,7,0,45,0,45s-1,51-62,76-146,62-146,62c-15,8.54-24.38,3-31,0l-105-49c-4.32-.66-7.15-3.76-5-15v-35Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-503 -576)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M979,1419l-17-344s0-32,17-49,123-140,227-179c16-6,29-10,29-10,8.33-1.7,16.73-2.65,26,6l75,90c13.66,14.15,14,25,14,41l4,121,60-4s-22-21-24-31,33-84,33-84c48.13-21.57,92.52-14.76,120,24l4,21s5-18,4-27,5.22-37.58,16-47c11.93-10.43,18-1,22,3l59,54c3.81,3.32,5,6,5,15v66c-.23,25.3-7.91,43.55-27,51,0,0-4,8-2,15s10,85-51,93-65,43-87,50-78,6-103,26c24,28,57,70,57,70,2.12,4,2.27,9,0,15,0,0-59,99-149,123-42,9-53,4-54-5-16,4-148,32-148,32-17,3-26,2-40-15l-67-90C978.46,1444.88,979,1434,979,1419Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bloque disjoncteur") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M541,1214V1055s-8-2-10-44-7-144-7-144-.09-19.37,18-59c21-46,122-205,186-224a48.18,48.18,0,0,1,26,0c14,4,107,42,107,42s38,18,37,62,0,100,0,100c17.92,25.6,20,49.2,0,70V966l-19,34,33,14v111s-6,19-10,23c1,7,0,45,0,45s-1,51-62,76-146,62-146,62c-15,8.54-24.38,3-31,0l-105-49c-4.32-.66-7.15-3.76-5-15v-35Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 759.69,
    cy: 1055.76,
    rx: 48.94,
    ry: 27.87,
    transform: "translate(-1008.02 783.5) rotate(-67.77)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 752.03,
    cy: 1052.63,
    rx: 44.95,
    ry: 19.59,
    transform: "translate(-1009.89 774.46) rotate(-67.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M879,1000s-27,49-29,58-6,38,0,46c15-19,68-96,68-96Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M902,1148v-5c0-7-4.92-13.56-12-16l-40-23,68-96-2,121Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M525,858.57S627.33,899.43,652,913c10,8,18,26,18,26l2,209,6,170s5,18,16,13-18,27-18,27l-160-75L503,867Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M538,844s98,46,111,44,20,3,30-17S799,683,865,660c0,0,22.8-11.08,7.9-26S748,576,748,576s-62,6-61,8S551,745,551,745l-14.82,76.54S531,841,538,844Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M579,1100l-27-12s-3,61,0,82,3.63,29.72,3.63,29.72Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M579,1100s-18,31-23,52,0,42,0,42l-2,31s0,2,9,9v25c-.61,6.4-.15,8.31,3,9l94,40c8.19,2.39,11.46-2.74,12-12V1150s-5-16-18-21S579,1100,579,1100Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M572,1174l49,49c5.38,3.17,9.32,2.34,12-2,0,0,19-26,19-47s-3-40-23-51-34-1-38,3-16,23-19,31S572,1174,572,1174Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M898,788v77.58S937,828,938,827s-32-48-32-48Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 841.75,
    cy: 1199.35,
    rx: 44.89,
    ry: 21.81,
    transform: "translate(-1089.93 948.71) rotate(-67.77)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 839.75,
    cy: 1199.35,
    rx: 42.02,
    ry: 18.66,
    transform: "translate(-1091.17 946.86) rotate(-67.77)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M979,1419l-17-344s0-32,17-49,123-140,227-179c16-6,29-10,29-10,8.33-1.7,16.73-2.65,26,6l75,90c13.66,14.15,14,25,14,41l4,121,60-4s-22-21-24-31,33-84,33-84c48.13-21.57,92.52-14.76,120,24l4,21s5-18,4-27,5.22-37.58,16-47c11.93-10.43,18-1,22,3l59,54c3.81,3.32,5,6,5,15v66c-.23,25.3-7.91,43.55-27,51,0,0-4,8-2,15s10,85-51,93-65,43-87,50-78,6-103,26c24,28,57,70,57,70,2.12,4,2.27,9,0,15,0,0-59,99-149,123-42,9-53,4-54-5-16,4-148,32-148,32-17,3-26,2-40-15l-67-90C978.46,1444.88,979,1434,979,1419Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M962.21,1079.3,1035,1154c11,12,16,21,15,42,0,0,11,333,13,348,6,11,17,21,17,21l-35-5-83-127-9-354Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M979,1289l63,72c5,5,6,13,6,25l8,134-64-77a14.71,14.71,0,0,1-4-10Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M964,1056l72,70c17.07,4.24,26-1,38-13,78.74-84.22,152.26-144.82,250-176,0,0,7.3-4.24,3.15-14.62S1251,821,1251,821l-86,34-92,75L964,1034Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1161.87,
    cy: 1313.1,
    rx: 46.83,
    ry: 32.55,
    transform: "translate(-1091.19 630.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1160.07,
    cy: 1311.29,
    rx: 46.83,
    ry: 30,
    transform: "translate(-1090.45 628.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1279.39,
    cy: 1457.11,
    rx: 45.06,
    ry: 30.05,
    transform: "translate(-1158.61 755.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1277.73,
    cy: 1455.45,
    rx: 45.06,
    ry: 27.7,
    transform: "translate(-1157.92 753.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1237,1523s48,11,97-25,34-81,28-93-21-45-69-39c-6-6-7-6-8-18s-1-15-1-15c-.92-5.56,2.44-11.26,7-17,0,0,52-54,64-62,4-3,4-13,4-13-3.14-54.91-3.19-114.27-5-146l60-4s22,15.77,66,18c46.33,2.34,69.9-32.46,68-36l-1-76,13-71,37-3,97,84-12,101-86,241-268,185-100,7v-10Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1399.29,1222c-8.16,19.51-26.25,30.65-41,25.6,1.74-1.6-1.26-41.6-1.66-65.47,9.19-8.62,20.83-12.08,30.73-7.94C1402.35,1180.47,1407.71,1201.88,1399.29,1222Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1303,1347s4,4,15-5,46-48,46-48,4-13-10-11-22,0-30,6-18,20-21,33A59.64,59.64,0,0,0,1303,1347Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1423,1235l-31,30c-2,7.58-.94,14,6,18l54-8s-45,4-49-3S1423,1235,1423,1235Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1496,1256s19-7,24-21,10-40,4-39-19,8-19,8,9-4,14,1-1,26-5,32S1496,1256,1496,1256Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1552,1226c-5,0-6.67,0-5-11,0,0,42-38,43-39,4.44-4.81,19,1.59,15,6,0,0-7,21-14,29s-8,10-19,13A59.2,59.2,0,0,1,1552,1226Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1354,1095l73,77c3.33,1.17,8,1.59,16,0l116-18s3-3,0-6c-2.42-2.42-34.83-32.22-47.23-43.61C1480,1118,1419,1100,1407.12,1084,1402,1085,1354,1095,1354,1095Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1422,1145c1,1,9,5,9,5l5-49.3-7-2.65Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1452,1105.3l-5,53.7s21,1,26-13,3.41-37.31,3.41-37.31C1467.29,1108.36,1458.78,1107.53,1452,1105.3Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1533.1,1092.4,1573,1141s32,1,46-43c0,0,9-40,8-61s-10-27-10-27-40-42-49-43-17.77,39.1-17.77,39.1l-2.22,16.61v42.78S1549.21,1079.81,1533.1,1092.4Z",
    transform: "translate(-503 -576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1383,1320s-35,24-35,39c9,6,19,8,26,37,3,12,19,12,51-5,11-4,11.47-3.69,15.74.65S1457,1381,1457,1381Z",
    transform: "translate(-503 -576)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 1476.5,
    cy: 992,
    rx: 16,
    ry: 35.5,
    transform: "translate(-171.58 1777.21) rotate(-83.82)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "939 511 961 516 971 455 949 449 939 511"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "930 438 916 493 899 477 919 424 930 438"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "990 519 999 458 1013 454 1005 515 990 519"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1030 496 1030 447 1037 435 1037 483 1030 496"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloqueDisjoncteur);
export default __webpack_public_path__ + "static/media/bloque_disjoncteur.b83c1ca6cdee9d449c41d537e33c920f.svg";
export { ForwardRef as ReactComponent };